module.exports = __webpack_public_path__ + "img/circle-xmark-sharp-solid.f537cd6a.svg";